import type { Release } from '../releases.ts';

export default {
  version: '0.14.1',
  date: '2026-10-02',
  title: 'Fixes',
  summary: [
    'Save a sequence as a new asset instead of exporting it',
    'Export downloads are kept 30 days by default',
    'Fixed: broadcast formats show as built-in transcode profiles',
    'Fixed: System status shows quota use and no longer lists removed locations',
    'Fixed: removed locations and agents are not brought back at startup',
  ],
  features: [
    'Save a sequence as a new asset instead of exporting it: stored by the storage tiers like any ingest (never in an export location), processed like an upload, with a title, a description of where it came from, the keywords of its media and relations to that media',
    'Export downloads (exports not sent to an export location) are kept for 30 days by default, set in System status → Housekeeping; the export dialogs call them “Download from PRISM”',
  ],
  fixes: [
    'The broadcast formats show as built-in profiles in Administration → Transcoding and can be used in the Transcode step',
    'System status → Storage shows quota use beside the disk, and no longer lists removed locations',
    'Exporting from the asset page updates its progress, and the Export button rests after a click so an export is not started twice',
    'Storage locations and agents created at startup are not brought back after someone removes them',
  ],
} satisfies Release;
